<template> 
  <div  :key="100" style="height:100%" :class="pageName=='caseName'?'case-name':'patientmanage-name'"> 
      <el-scrollbar style="height: 100%" wrap-style="overflow-x:hidden;">
        <el-form class="form-class" :model="ruleForm" :rules="rulesqw" size="mini" ref="ruleForm" label-width="200px"
          label-position="left">
          <el-form-item v-if="$route.query.userId" label="用户ID:" style="font-weight:600;font-size:16px">
            <p style="font-weight:600;font-size:16px">{{$route.query.userId}}</p>
          </el-form-item>
          <el-form-item label="当前账号与当前患者的关系:">
            <p>{{ruleForm.kinshipName}}</p>
          </el-form-item>
          <el-form-item label="姓名:">
            <p>{{ruleForm.patientName}}</p>
          </el-form-item>

          <el-form-item label="性别:">
            <p>{{ ruleForm.sex == 1 ? '男' : ruleForm.sex == 2 ? '女' : '未知' }}</p>
          </el-form-item>

          <el-form-item label="年龄:">
            <p>{{ruleForm.age}}</p>
          </el-form-item>

          <el-form-item label="民族:">
            <p>{{ruleForm.nation}}</p>
          </el-form-item>

          <el-form-item label="籍贯:">
            <p>{{ruleForm.nativePlace}}</p>
          </el-form-item>

          <el-form-item label="血型:">
            <p v-if="!isEdit">{{ruleForm.bloodType | bloodTypeFilt}}</p>
            <el-select v-model="ruleForm.bloodType" v-else>
              <el-option :label="item.label" :value="item.value" v-for="(item,index) in bloodTypeList" :key="index">
              </el-option>
            </el-select>
          </el-form-item>  
          <el-form-item label="出生日期:">
            <p>{{ruleForm.birthday}}</p>
          </el-form-item>
          <el-form-item label="职业:">
            <p>{{ruleForm.occupation}}</p>
          </el-form-item> 
          <el-form-item label="是否孕产妇:" v-if="ruleForm.sex == 2">
            <p v-if="!isEdit">{{ruleForm.pregnancyStatus == 1 ? '是' : '否'}}</p>
            <el-select v-model="ruleForm.pregnancyStatus" v-else>
              <el-option v-for="(item,index) in pregnancyStatusList" :key="index" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="孕前末次月经:" v-if="ruleForm.pregnancyStatus == 1"> 
            <el-date-picker v-if='isEdit' :picker-options="lastMenstrualPeriodPickerOptions" value-format="yyyy-MM-dd"
              :clearable="false" v-model="ruleForm.lastMenstrualPeriod" type="date" placeholder="选择日期">
            </el-date-picker>
            <linkHistory v-else name='孕前末次月经' eventName='基本信息' patientFilesId='-1' :date='ruleForm.lastMenstrualPeriod' :dateList='ruleForm.lastMenstrualPeriodHistory'/>
          </el-form-item>   
          <el-form-item label="末次月经:"  v-if="ruleForm.sex == 2">
             <el-date-picker v-if="isEdit" :picker-options="lastMenstrualPeriodPickerOptions" value-format="yyyy-MM-dd"
                :clearable="false" v-model="ruleForm.newMenstrualPeriod" type="date" placeholder="选择日期">
              </el-date-picker> 
            <linkHistory v-else name='末次月经' @getUpTime='getUpTime'  eventName='基本信息' patientFilesId='-1' :date='ruleForm.newMenstrualPeriod' :dateList='ruleForm.newMenstrualPeriodHistory'/>
          </el-form-item>  
          
          <el-form-item label="体力劳动等级:">
            <p v-if="!isEdit">{{ruleForm.labour | labourFilte}}</p>
            <el-select v-model="ruleForm.labour" placeholder="请选择活动区域" v-else>
              <el-option v-for="(item,index) in labourTypeList" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="证件类型:">
            <p>{{ruleForm.certificate}}</p>
          </el-form-item>
          <template v-if="!ruleForm.logOff">
            <el-form-item label="证件号码:">
              <p>{{ruleForm.idCard}}</p>
            </el-form-item> 
            <el-form-item label="联系方式:">
              <p>{{ruleForm.mobile}}</p>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item label="证件号码-注销前:">
              <p>{{ruleForm.idCardBefore}}</p>
            </el-form-item> 
            <el-form-item label="联系方式-注销前:">
              <p>{{ruleForm.mobileBefore}}</p>
            </el-form-item>
             <el-form-item label="注销时间:">
              <p>{{ruleForm.logOffTime}}</p>
            </el-form-item>
             <el-form-item label="注销状态:">
              <p>已注销</p>
            </el-form-item>
          </template> 
          <el-form-item label="当前居住地址:">
            <p>{{ruleForm.province}}{{ruleForm.city}}{{ruleForm.county}}{{ruleForm.address}}</p>
          </el-form-item> 
          <el-form-item label="亲属:">
            <div style="display: flex; align-items: center;">
              <p v-if="ruleForm.relativeVO.name">{{ruleForm.relativeVO.name}}</p>
              <p v-else>暂无关联</p>
              <div style="margin-left:120px;position:relative">
                <el-button size="small" slot="reference" type="text" @click="editKinsFolkInfo">编辑信息</el-button>
                <!-- 亲属信息 -->
                <div class="kins-folk-info">
                  <KinsfolkInfo v-if="showKinsPop" :showKinsPop.sync="showKinsPop" @recieveRelative="recieveRelative"></KinsfolkInfo>
                </div>
              </div>
            </div>
          </el-form-item> 

          <el-form-item label="当前体重占理想体重(%):">
            <p>{{ruleForm.weightIbm}}</p>
          </el-form-item>

          <el-form-item label="预产期:" v-if="ruleForm.pregnancyStatus == 1"> 
            <el-date-picker v-if="isEdit"  v-model="ruleForm.predictChildbirth" value-format="yyyy-MM-dd"
              :picker-options="predictChildbirthPickerOptions" :clearable="false" type="date" placeholder="选择日期">
            </el-date-picker> 
            <linkHistory v-else name='预产期' eventName='基本信息' patientFilesId='-1'  :date='ruleForm.predictChildbirth' :dateList='ruleForm.predictChildbirthHistory'/>
          </el-form-item>

          <el-form-item label="胎数:" v-show="ruleForm.pregnancyStatus == 1">
            <p v-if="!isEdit">{{ruleForm.embryoNumber | embryoNumberFilte}}</p>
            <el-select v-model="ruleForm.embryoNumber" v-else>
              <el-option v-for="(item,index) in embryoNumberList" :key="index" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="当前身高(cm):">
            <p v-if="!isEdit">{{ruleForm.height}}</p> 
            <el-input v-else v-model.trim="ruleForm.height" controls-position="right" :min="1"
              placeholder="请输入当前身高">
            </el-input>
          </el-form-item>

          <el-form-item label="当前体重(kg):">
            <p v-if="!isEdit">{{ruleForm.weight}} </p>
            <el-input v-else v-model.trim="ruleForm.weight" controls-position="right" :min="1"
              placeholder="请输入当前体重">
            </el-input> 
          </el-form-item>

          <el-form-item label="孕前体重(kg):" v-if="ruleForm.pregnancyStatus == 1">
            <p v-if="!isEdit">{{ruleForm.pregnancyWeight}}</p>
            <el-input v-else v-model.trim="ruleForm.pregnancyWeight" controls-position="right" :min="1">
            </el-input>
          </el-form-item>

          <el-form-item label="理想体重(IBW):">
            <p>{{ruleForm.ibw}}</p>
          </el-form-item>

          <el-form-item label="BMI(kg/m²):">
            <p>{{ruleForm.bmi}}</p>
          </el-form-item>

          <el-form-item label="孕前BMI(kg/m²):" v-if="ruleForm.pregnancyStatus == 1">
            <p>{{ruleForm.pregnancyBmi}}</p>
          </el-form-item>

          <el-form-item label="腰围(cm):"> 
            <p v-if="!isEdit">{{ruleForm.waistline}}</p>
            <el-input type="text" v-else v-model.trim="ruleForm.waistline" placeholder="请输入当前腰围">
            </el-input>
          </el-form-item>

          <el-form-item label="臀围(cm):">
            <p v-if="!isEdit">{{ruleForm.hipline}}</p>
            <el-input type="text" v-else v-model.trim="ruleForm.hipline" placeholder="请输入当前臀围">
            </el-input>
          </el-form-item>

          <el-form-item label="孕周:" v-if="ruleForm.pregnancyStatus == 1">
            <p v-if="!isEdit">{{ruleForm.gestationalWeeks | gestationalWeeksFilts}}</p>
            <el-select v-model="ruleForm.gestationalWeeks" v-else>
              <el-option v-for="(item,index) in gestationalWeeksList" :key="index" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="腰臀比:">
            <p>{{ruleForm.whr}}</p>
          </el-form-item>

          <el-form-item label="基础代谢(kcal):">
            <p v-if="!isEdit">{{ruleForm.kcal}}</p>
            <el-input type="text" v-else v-model.trim="ruleForm.kcal" placeholder="请输入基础代谢">
            </el-input>
          </el-form-item>

          <el-form-item label="营养风险:">
            <p>{{ruleForm.nutritionalRisk}}</p>
          </el-form-item>
          <!-- v-if="$store.state.serviceItem.hospitalId == '1630497377808076802'" -->
          <!-- 机构自定义 -->
          <div v-if="orgHospitalId == '1630497377808076802'">
            <div class="open-tag">
              <div class="tag-title"><span></span><p>机构自定义</p></div>
              <div class="open-status" v-if="openCustom" @click="handleFoldCustom">收起 <i class="el-icon-arrow-up"></i> </div>
              <div class="open-status" v-else @click="handleFoldCustom">展开 <i class="el-icon-arrow-down"></i> </div>
            </div>
            <div v-show="openCustom"> 
              <el-form-item label="会员卡号:">
                <div style="display: flex; justify-content: space-between;" v-if="customForm.membershipCardNumber && customForm.membershipCardNumber !='' && customForm.membershipCardNumber !='-'">
                  {{customForm.membershipCardNumber}} 
                  <el-popover
                    placement="top"
                    width="200"
                    v-model="cardvisible">
                    <div>
                      <div class="fill-card-title">输入补卡原因：</div>
                      <el-input type="text" v-model.trim="reason" maxlength="50" placeholder="请输入补卡原因"></el-input>
                      <div style="margin-top:16px;text-align:center">
                        <el-button size="mini" @click="cardvisible = false">取 消</el-button>
                        <el-button size="mini" type="primary" v-preventReClick @click="confirmApplyCard">确定</el-button>
                      </div>
                    </div>
                    <el-button slot="reference" size="small" type="text" @click="reason=''">补卡</el-button>
                  </el-popover>
                </div>
                <div style="display: flex; justify-content: space-between;" v-else>
                  {{customForm.membershipCardNumber}} 
                </div>
                <div v-if="fillCardList.length">
                  <p v-if="!showAllVipCard">
                    <!-- <span style="display:inline-block;margin-right:20px;">{{fillCardList[0].cardNumber}}</span> -->
                    <el-tooltip placement="right">
                      <div slot="content">{{fillCardList[0].reapplyDate}}<br/>补卡原因：{{fillCardList[0].reason}}</div>
                      <el-button size="small" type="text">补卡记录{{fillCardList.length}}</el-button>
                    </el-tooltip>
                  </p>
                  <p v-show="showAllVipCard" v-for="(item,index) in fillCardList" :key="index">
                    <!-- <span style="display:inline-block;margin-right:20px;">{{item.cardNumber}}</span> -->
                    <el-tooltip placement="right">
                      <div slot="content">{{item.reapplyDate}}<br/>补卡原因：{{item.reason}}</div>
                      <el-button size="small" type="text">补卡记录{{fillCardList.length - index}}</el-button>
                    </el-tooltip>
                  </p>
                  <el-button v-if="fillCardList.length > 1 && !showAllVipCard" size="small" type="text" @click="showAllVipCard = true">展示更多</el-button>
                  <el-button v-if="fillCardList.length > 1 && showAllVipCard" size="small" type="text" @click="showAllVipCard = false">收起</el-button>
                </div>
              </el-form-item>

              <el-form-item label="工作单位:">
                <p v-if="!isEdit">{{customForm.workingOrgan}}</p>
                <el-input type="text" v-else v-model.trim="customForm.workingOrgan" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="职务工种:">
                <p v-if="!isEdit">{{customForm.profession}}</p>
                <el-input type="text" v-else v-model.trim="customForm.profession" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="现有文化程度:">
                <p v-if="!isEdit">{{customForm.educationalLevel}}</p>
                <el-select v-else v-model="customForm.educationalLevel" placeholder="请选择" clearable>
                  <el-option label="博士及以上" value="博士及以上"></el-option>
                  <el-option label="研究生" value="研究生"></el-option>
                  <el-option label="本科" value="本科"></el-option>
                  <el-option label="大专" value="大专"></el-option>
                  <el-option label="高专" value="高专"></el-option>
                  <el-option label="中专" value="中专"></el-option>
                  <el-option label="技工学校" value="技工学校"></el-option>
                  <el-option label="高中" value="高中"></el-option>
                  <el-option label="初中" value="初中"></el-option>
                  <el-option label="小学" value="小学"></el-option>
                  <el-option label="文盲或半文盲" value="文盲或半文盲"></el-option>
                </el-select>
                <!-- <el-input type="text" v-else v-model.trim="customForm.educationalLevel" placeholder="请输入内容">
                </el-input> -->
              </el-form-item>
              <el-form-item label="何年参加何党派团体:">
                <p v-if="!isEdit">{{customForm.joinPartyTime}}{{customForm.politicalBackground}}</p>
                <div v-else style="display:flex;flex:1;">
                  <el-date-picker v-model="customForm.joinPartyTime" value-format="yyyy-MM-dd" style="margin-right: 4px"
                    type="date" placeholder="选择日期">
                  </el-date-picker>
                  <el-input type="text" v-model.trim="customForm.politicalBackground" placeholder="请输入内容" maxlength="255">
                  </el-input>
                </div>
              </el-form-item>
              <el-form-item label="懂得何种外语:">
                <p v-if="!isEdit">{{customForm.languageSkills}}</p>
                <el-input type="text" v-else v-model.trim="customForm.languageSkills" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="特长与爱好:">
                <p v-if="!isEdit">{{customForm.specialtyAndHobbies}}</p>
                <el-input type="textarea" v-else v-model.trim="customForm.specialtyAndHobbies" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="宗教信仰:">
                <p v-if="!isEdit">{{customForm.religiousBelief}}</p>
                <el-input type="text" v-else v-model.trim="customForm.religiousBelief" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item> 
              <el-form-item label="家庭地址:">
                <p v-if="!isEdit">{{customForm.province}}{{customForm.city}}{{customForm.county}}</p>
                <el-cascader v-else placeholder="选择或者搜索" v-model="customForm.cityList" :props="setKesDept"
                  :options="options" filterable clearable @change="addressChange" style="width:100%;">
                </el-cascader>
              </el-form-item>
              <el-form-item label="详细地址:">
                <p v-if="!isEdit">{{customForm.address}}</p>
                <el-input v-else type="text" v-model.trim="customForm.address" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="邮政编码:">
                <p v-if="!isEdit">{{customForm.postalCode}}</p>
                <el-input type="text" v-else v-model.trim="customForm.postalCode" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="紧急联系人:">
                <p v-if="!isEdit">{{customForm.emergencyContact}}</p>
                <el-input type="text" v-else v-model.trim="customForm.emergencyContact" placeholder="请输入内容"
                  maxlength="10">
                </el-input>
              </el-form-item>
              <el-form-item label="紧急联系人手机号码:">
                <p v-if="!isEdit">{{customForm.emergencyContactNumber}}</p>
                <el-input type="text" v-else v-model.trim="customForm.emergencyContactNumber" placeholder="请输入内容"
                  maxlength="11">
                </el-input>
              </el-form-item>
              <el-form-item label="癌症名称:">
                  <p v-if="!isEdit">{{customForm.cancerNameText}}</p>
                  <el-select v-else v-model="customForm.cancerNameText" @change="cancerNameTextChange" placeholder="请选择"
                    clearable style="width:100%;">
                    <el-option v-for="(item,index) in cancerNameList" :key="index" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                  <p v-if="customForm.cancerNameText == '其他' && !isEdit">{{customForm.cancerName}}</p>
                  <el-input type="text" v-if="customForm.cancerNameText == '其他' && isEdit"
                    v-model.trim="customForm.cancerName" placeholder="请输入内容" maxlength="255">
                  </el-input>
                </el-form-item>
              <!-- <el-form-item label="联系人:">
                <p v-if="!isEdit">{{customForm.contacts}}</p>
                <el-input type="text" v-else v-model.trim="customForm.contacts" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item> -->
              <el-form-item label="确诊医院:">
                <p v-if="!isEdit">{{customForm.confirmedDiagnosisHospital}}</p>
                <el-input type="text" v-else v-model.trim="customForm.confirmedDiagnosisHospital" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="确诊日期:">
                <p v-if="!isEdit">{{customForm.confirmedDiagnosisTime}}</p>
                <el-date-picker v-else v-model="customForm.confirmedDiagnosisTime" value-format="yyyy-MM-dd"
                  type="date" placeholder="选择日期">
                </el-date-picker>
              </el-form-item>

              <el-form-item label="治疗简况:">
                <p v-if="!isEdit">{{customForm.treatment.join(',')}}</p>
                <el-checkbox-group v-else v-model="customForm.treatment">
                  <el-checkbox label="手术"></el-checkbox>
                  <el-checkbox label="化疗"></el-checkbox>
                  <el-checkbox label="放疗"></el-checkbox>
                  <el-checkbox label="免疫治疗"></el-checkbox>
                  <el-checkbox label="中医中药"></el-checkbox>
                  <el-checkbox label="其它"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="体能锻炼:">
                <p v-if="!isEdit">{{customForm.physicalExercise.join(',')}}  {{otherExercise}}</p>
                <el-checkbox-group v-else v-model="customForm.physicalExercise">
                  <el-checkbox label="郭林新气功"></el-checkbox>
                  <el-checkbox label="其它气功"></el-checkbox>
                  <el-checkbox label="太极拳"></el-checkbox>
                  <el-checkbox label="太极剑"></el-checkbox>
                  <el-checkbox label="保健操"></el-checkbox>
                  <el-checkbox label="交际舞"></el-checkbox>
                  <el-checkbox label="慢跑"></el-checkbox>
                  <el-checkbox label="散步"></el-checkbox>
                  <el-checkbox label="其它"></el-checkbox>
                </el-checkbox-group>
                <el-input v-if="isEdit && customForm.physicalExercise.indexOf('其它') != -1" type="text" v-model.trim="otherExercise" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="现在属于:">
                <p v-if="!isEdit">{{customForm.personalSituation.join(',')}}</p>
                <el-checkbox-group v-else v-model="customForm.personalSituation">
                  <el-checkbox label="病假"></el-checkbox>
                  <el-checkbox label="退养"></el-checkbox>
                  <el-checkbox label="退休（是）"></el-checkbox>
                  <el-checkbox label="离休"></el-checkbox>
                  <el-checkbox label="上班"></el-checkbox>
                  <el-checkbox label="志愿者"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="爱人姓名:">
                <p v-if="!isEdit">{{customForm.spouseName}}</p>
                <el-input type="text" v-else v-model.trim="customForm.spouseName" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="病孩家长姓名:">
                <p v-if="!isEdit">{{customForm.parentName}}</p>
                <el-input type="text" v-else v-model.trim="customForm.parentName" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="病孩家长工作单位及职务:">
                <p v-if="!isEdit">{{customForm.parentWorkingOrgan}}{{customForm.parentProfession}}</p>
                <div v-if="isEdit" style="display:flex">
                  <el-input type="text" v-model.trim="customForm.parentWorkingOrgan" placeholder="请输入内容" style="margin-right:10px" maxlength="255">
                  </el-input>
                  <el-input type="text" v-model.trim="customForm.parentProfession" placeholder="请输入内容" maxlength="255">
                  </el-input>
                </div>
              </el-form-item>
              <el-form-item label="家长联系电话:">
                <p v-if="!isEdit">{{customForm.parentPhone}}</p>
                <el-input type="text" v-else v-model.trim="customForm.parentPhone" maxlength="11" placeholder="请输入内容">
                </el-input>
              </el-form-item>
              <el-form-item label="入会目的:">
                <p v-if="!isEdit">{{customForm.purpose}}</p>
                <el-input type="textarea" v-else v-model.trim="customForm.purpose" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="建议和愿望:">
                <p v-if="!isEdit">{{customForm.suggestionsAndWishes}}</p>
                <el-input type="textarea" v-else v-model.trim="customForm.suggestionsAndWishes" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="离、退休或退养时间:">
                <p v-if="!isEdit">{{customForm.retiredTime}}</p> 
                <el-date-picker v-else v-model="customForm.retiredTime" value-format="yyyy-MM-dd" style="margin-right: 4px"
                  :clearable="false" type="date" placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="入会介绍人:">
                <p v-if="!isEdit">{{customForm.introducer}}</p>
                <el-input type="text" v-else v-model.trim="customForm.introducer" placeholder="请输入内容" maxlength="255">
                </el-input>
              </el-form-item>
              <el-form-item label="本人照片:"> 
                <el-image 
                  v-if="customForm.photo"
                  style="width:56px"
                  :src="customForm.photo" 
                  :preview-src-list="[customForm.photo]">
                </el-image>
              </el-form-item>
              <el-form-item label="身份证照片:">
                <span>
                  <el-image 
                    v-if="customForm.idCardFront"
                    style="margin-right:10px;width:110px"
                    :src="customForm.idCardFront" 
                    :preview-src-list="[customForm.idCardFront,customForm.idCardBack]">
                  </el-image>
                  <el-image 
                    v-if="customForm.idCardBack"
                    style="width:110px"
                    :src="customForm.idCardBack" 
                    :preview-src-list="[customForm.idCardFront,customForm.idCardBack]">
                  </el-image>
                  <!-- <img :src="customForm.idCardFront" alt="" style="margin-right:10px;width:110px">
                  <img :src="customForm.idCardBack" alt="" style="width:110px"> -->
                </span>
              </el-form-item>
              <el-form-item label="病历照片:">
                <span>
                  <el-image v-for="(item,i) in customForm.casePhotoNew" :key="i"
                    style="width:110px;height:146px;margin-right:10px;" :src="item" :preview-src-list='[item]'>
                  </el-image>
                </span>
              </el-form-item>
            </div>
          </div>
        </el-form>

        <!-- 新增术语 -->
        <el-form size="mini" class="tooltip-form" label-width="142px" label-position="left" label-suffix=":">
          <el-tooltip class="item" effect="dark" :content="item.name" placement="left" v-for="(item, key) in jargonList"
            :key="key" :disabled="item.name && item.name.length <= 8">
            <el-form-item :label="item.name && item.name.length > 8 ? item.name.slice(0, 8) + '……' : item.name">
              <p v-if="!isEdit">{{ item.value }}</p>
              <el-date-picker v-if="isEdit && item.recordType === 'date'" value-format="yyyy-MM-dd" :clearable="false"
                v-model="item.value" type="date" placeholder="选择日期">
              </el-date-picker>
              <el-input v-if="isEdit && item.recordType === 'number'" v-model.trim="item.value"
                controls-position="right" :min="1" placeholder="请输入当前体重">
              </el-input>
              <el-input v-if="isEdit && item.recordType === 'string'" v-model.trim="item.value">
              </el-input>
            </el-form-item>
          </el-tooltip>
        </el-form>
      </el-scrollbar> 
  </div>
</template>

<script>
import local from "@/utils/local.js";
import { DEEP_CLONE } from '@/utils/constants'
import {
  selectByPatientIdAndHospitalId,
  reapplyVipCard,
  newReapplyRecord,
  updateCustome
} from "@/api/Patientmanagement.js";
import { UpdatepatientArchiesLeft, terminologyMultipleInsert, regionAll } from "../../api";
export default {
  name: "UserDetails",
  props: {
    pageName:{ //区分哪个页面调用此组件 （目前 病人管理基本信息||疗管个人信息-基本信息）
      type: String,
      default: null
    },
    userDetailsData: {
      type: Object,
      default: () => {}
    }, 
    jargonList: {
      type: Array,
      default: () => {
        [];
      }
    }
  },
  components: {
    RelateChain: () =>
      import("@/views/treatment/components/CrossReferenceEntry/RelateChain.vue"),
    linkHistory: () => import("./linkHistory.vue"),
    KinsfolkInfo: () => import("@/components/KinsfolkInfo.vue")
  },
  data() {
    return {
      time1:false,
      otherExercise: '',
      orgHospitalId: local.get('hospitalId'),
      showAllVipCard: false,
      fillCardList: [],
      reason: '',
      cardvisible: false,
      customForm: {
        treatment:[],
        physicalExercise:[],
        personalSituation:[]
      },
      openCustom: true,
      predictChildbirthPickerOptions: {
        //禁用当前日之前的时间
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        }
      },
      lastMenstrualPeriodPickerOptions: {
        //只能选当天日期之前的
        disabledDate(time) {
          return time.getTime() >= Date.now() - 24 * 60 * 60 * 1000;
        }
      },
      showKinsPop: false,
      tab: 1,
      address: "",
      ruleForm: {
        patientName: "", //姓名
        sex: "", //性别 1男 2女
        age: "", //年龄
        bloodType: "", //血型
        nation: "", //民族
        nativePlace: "", //籍贯
        maritalStatus: "", //1 已婚 2 未婚
        birthday: "", //出生日期
        pregnancyStatus: "", //是否孕妇 1是 2否
        occupation: "", //职业
        labour: "", //体力劳动等级 1轻体力劳动 2 中等体力劳动 3重体力劳动 4极重体力劳动
        certificate: "", //证件类型 未知枚举
        idCard: "", //证件号码
        mobile: "", //	联系方式
        address: "", //	当前居住地址
        province: "", //省
        city: "", //市
        county: "", //区
        lastMenstrualPeriod: "", //孕前末次月经
        lastMenstrualPeriodHistory:[],
        newMenstrualPeriod:"",
        newMenstrualPeriodHistory:[],
        predictChildbirth: "", //预产期
        embryoNumber: "", //胎数 1 单胎 2 双胎 3 多胎
        height: "", //当前身高
        weight: "", //当前体重
        pregnancyWeight: "", //孕前体重
        ibw: "", //理想体重
        weightIbm: "", //当前体重占理想体重
        bmi: "", //BMI
        pregnancyBmi: "", //孕前BMI
        waistline: "", //腰围
        hipline: "", //臀围
        gestationalWeeks: "", //孕周
        whr: "", //腰臀比
        kcal: "", //基础代谢
        nutritionalRisk: "", //营养风险:
        id: "",
        relativeVO: {},
        logOff: false,
        logOffTime: '',
        idCardBefore: '',
        mobileBefore: '',
        kinshipName: ""
      },
      rulesqw: {
        bloodType: [{ message: "请选择血型", trigger: "change" }],
        pregnancyStatus: [{ message: "请选择是否孕产妇", trigger: "change" }],
        labour: [{ message: "请选择体力劳动等级", trigger: "change" }],
        lastMenstrualPeriod: [
          { message: "请选择孕前末次月经时间", trigger: "change" }
        ],
        predictChildbirth: [{ message: "请选择预产期", trigger: "change" }],
        embryoNumber1: [{ message: "请选择胎数", trigger: "change" }],
        height: [
          // {  message: '请输入当前身高', type:'number', trigger: 'blur' },
          { message: "请输入当前身高", trigger: "blur" }
        ],
        weight: [{ message: "请输入当前体重", trigger: "blur" }]
        // pregnancyWeightOne: [
        //     {  message: '请输入孕前体重', trigger: 'blur' },
        // ],
      }, //输入规则
      jargonObj: {}, // 新增术语
      isEdit: false, //false预览 true 编辑
      bloodTypeList: [
        //血型列表
        {
          label: "A型",
          value: 1
        },
        {
          label: "B型",
          value: 2
        },
        {
          label: "AB型",
          value: 3
        },
        {
          label: "O型",
          value: 4
        },
        {
          label: "不清楚",
          value: 5
        }
      ],
      pregnancyStatusList: [
        //是否孕产妇
        {
          label: "是",
          value: 1
        },
        {
          label: "否",
          value: 2
        }
      ],
      labourTypeList: [
        //体力劳动等级
        {
          label: "轻体力劳动",
          value: 1
        },
        {
          label: "中等体力劳动",
          value: 2
        },
        {
          label: "重体力劳动",
          value: 3
        },
        {
          label: "极重体力劳动",
          value: 4
        }
      ],
      embryoNumberList: [
        //胎数
        {
          label: "单胎",
          value: 1
        },
        {
          label: "双胎",
          value: 2
        },
        {
          label: "多胎",
          value: 3
        }
      ],
      gestationalWeeksList: [], //孕周
      // drawer: true,
      options: [],
      setKesDept: {
        value: "name",
        label: "name"
      },
      // jargonList: [],
      cancerNameList: [
        {
          label: "肺病种组",
          value: "肺病种组"
        },
        {
          label: "肝病种组",
          value: "肝病种组"
        },
        {
          label: "肠病种组",
          value: "肠病种组"
        },
        {
          label: "乳腺系组",
          value: "乳腺系组"
        },
        {
          label: "胃病种组",
          value: "胃病种组"
        },
        {
          label: "泌尿系组",
          value: "泌尿系组"
        },
        {
          label: "甲状腺组",
          value: "甲状腺组"
        },
        {
          label: "鼻咽喉组",
          value: "鼻咽喉组"
        },
        {
          label: "妇科系组",
          value: "妇科系组"
        },
        {
          label: "其他",
          value: "其他"
        }
      ]
    };
  },
  created() {  
    this.regionAll();
    let arr = [];
    for (let i = 1; i <= 50; i++) {
      if (i <= 12) {
        arr.push({
          label: ` ${i} ` + "[孕早期]",
          value: i
        });
      } else if (i <= 25) {
        arr.push({
          label: ` ${i} ` + "[孕中期]",
          value: i
        });
      } else {
        arr.push({
          label: ` ${i} ` + "[孕晚期]",
          value: i
        });
      }
    }
    this.gestationalWeeksList = arr;
  },
  watch: { 
    // async userDetailsData(val) {  
    //   console.log('watch',val)
    //   if (this.orgHospitalId == '1630497377808076802') {
    //     // await this.getHzPatientData()
    //     this.getVipCardInfo()
    //   } 
    //   return this.getDataDetail(val);
    // },
    userDetailsData:{
      handler(val){  
        console.log('userDetailsData', val)
        if (this.orgHospitalId == '1630497377808076802') {
         this.getHzPatientData()
         this.getVipCardInfo()
        } 
      return this.getDataDetail(val);
      },
      immediate:true,
      deep:true
    } 
  }, 
  methods: { 
    getUpTime(){ 
      this.$emit("userEdit", 1);
    },
    onEditeBasic(type){  
      if(type == 'edite'){
        this.isEdit = true 
      }else{
        this.submitHandel()
      } 
    },
    async getVipCardInfo() {
      this.fillCardList = []
      let res = await newReapplyRecord({
        hospitalId: '1630497377808076802',
        patientId: this.userDetailsData.patientId
      })
      if (res.code == 0) {
        if (res.data) {
          this.fillCardList = res.data
        } 
      }
    },
    async confirmApplyCard() {
      if (!this.reason) {
        this.$message.error('请输入补卡原因')
        return
      }
      let res = await reapplyVipCard({
        hospitalId: '1630497377808076802',
        patientId: this.userDetailsData.patientId,
        reason: this.reason
      })
      if (res.code == 0) {
        this.cardvisible = false
        this.getVipCardInfo()
      }
    },
    async getHzPatientData() { 
      let res = await selectByPatientIdAndHospitalId({
        hospitalId: '1630497377808076802', // this.$store.state.serviceItem.hospitalId,
        patientId: this.userDetailsData.patientId
      })
      if (res.code == 0) {
        if (res.data) {
          res.data.treatment = res.data.treatment?res.data.treatment.split(','):[]
          res.data.physicalExercise = res.data.physicalExercise?res.data.physicalExercise.split(','):[]
          if (res.data.physicalExercise.indexOf('其它') != -1 && res.data.physicalExercise[res.data.physicalExercise.length - 1] != '其它') {
            this.otherExercise = res.data.physicalExercise[res.data.physicalExercise.length - 1]
            res.data.physicalExercise.pop()
          }
          res.data.personalSituation = res.data.personalSituation?res.data.personalSituation.split(','):[]
          this.customForm = res.data,
          this.customForm.casePhotoNew = res.data.casePhoto
            ? res.data.casePhoto.split(",")
            : [];
          let arrCancer = this.cancerNameList.filter(item => {
            return item.value == res.data.cancerName;
          });
          if (arrCancer.length > 0) {
            this.customForm.cancerNameText = res.data.cancerName;
          } else {
            this.customForm.cancerName = res.data.cancerName;
            this.customForm.cancerNameText = "其他";
          }
          this.$set(this.customForm, "cityList", []);
          this.customForm.cityList[0] = res.data.province;
          this.customForm.cityList[1] = res.data.city;
          this.customForm.cityList[2] = res.data.county;
        } else {
          this.customForm = {
            treatment:[],
            physicalExercise:[],
            personalSituation:[]
          }
        }
      }
    },
    handleFoldCustom() {
      this.openCustom = !this.openCustom
    },
    recieveRelative(data) { 
      const paramValue = this.ruleForm.relativeVO
      this.ruleForm.relativeVO = Object.assign({}, paramValue, { name: data.name })
    },
    editKinsFolkInfo() {
      this.showKinsPop = true
    }, 
    getDataDetail(value) {
      if (!value) return false;
      Object.keys(this.ruleForm).forEach(item => {
        if (["height", "weight", "pregnancyWeight"].includes(item))
          this.ruleForm[item] = value[item] * 1 || undefined;
        else this.ruleForm[item] = value[item] || "";
      });
      // 如果档案数据为空，取杭州分会下填入的数据
      // 如果档案有数据，则以档案的显示 
      this.ruleForm.sex = this.ruleForm.sex ? this.ruleForm.sex : this.customForm.sex
      this.ruleForm.patientName = this.ruleForm.patientName ? this.ruleForm.patientName : this.customForm.patientName
      this.ruleForm.nation = this.ruleForm.nation ? this.ruleForm.nation : this.customForm.nation
      this.ruleForm.mobile = this.ruleForm.mobile ? this.ruleForm.mobile : this.customForm.mobile
      this.ruleForm.idCard = this.ruleForm.idCard ? this.ruleForm.idCard : this.customForm.idCard
      this.ruleForm.birthday = this.ruleForm.birthday ? this.ruleForm.birthday : this.customForm.birthday
      this.ruleForm.address = this.ruleForm.address ? this.ruleForm.address : this.customForm.address 
      return this.ruleForm;
    }, 
    // 保存
    submitHandel() {
      let phoneReg = /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/
      if (this.isEdit) {
        if (this.orgHospitalId == '1630497377808076802') {
          if (!this.customForm.workingOrgan) {
            this.$message.error('请输入工作单位')
            return
          }
          if (!this.customForm.profession) {
            this.$message.error('请输入职务工种')
            return
          }
          if (!this.customForm.educationalLevel) {
            this.$message.error('请选择现有文化程度')
            return
          }
          if (!this.customForm.joinPartyTime || !this.customForm.politicalBackground) {
            this.$message.error('请填选何年参加何党派团体')
            return
          }
          if (!this.customForm.specialtyAndHobbies) {
            this.$message.error('请输入特长与爱好')
            return
          }

          if (!this.customForm.religiousBelief) {
            this.$message.error('请输入宗教信仰')
            return
          }

          if (this.customForm.cityList.length <= 0) {
            this.$message.error("请选择家庭地址");
            return;
          }
          if (
            this.customForm.address == null ||
            this.customForm.address == ""
          ) {
            this.$message.error("请输入详细地址");
            return;
          }
          if (
            this.customForm.emergencyContact == null ||
            this.customForm.emergencyContact == ""
          ) {
            this.$message.error("请输入紧急联系人");
            return;
          }
          if (
            this.customForm.emergencyContactNumber == null ||
            this.customForm.emergencyContactNumber == ""
          ) {
            this.$message.error("请输入紧急联系人手机号码");
            return;
          } else if (
            this.customForm.emergencyContactNumber &&
            !phoneReg.test(this.customForm.emergencyContactNumber)
          ) {
            this.$message.error("请输入正确格式的紧急联系人手机号码");
            return;
          }

          if (
            !this.customForm.cancerNameText ||
            this.customForm.cancerNameText == ""
          ) {
            this.$message.error("请选择癌症名称");
            return;
          } else if (
            this.customForm.cancerNameText == "其他" &&
            (this.customForm.cancerName == "" ||
              this.customForm.cancerName == null)
          ) {
            this.$message.error("请填写其他癌症名称");
            return;
          } 
          if (!this.customForm.confirmedDiagnosisTime) {
            this.$message.error('请选择确诊日期')
            return
          }
          if (this.customForm.treatment.length == 0) {
            this.$message.error('请选择治疗简况')
            return
          }
          if (!this.customForm.purpose) {
            this.$message.error('请填写入会目的')
            return
          }
        } 
        if (this.customForm.parentPhone && !phoneReg.test(this.customForm.parentPhone)) {
          this.$message.error("请输入正确格式的家长联系电话")
          return
        }
          if (this.ruleForm.height) {
          if (!/^\d+(\.\d+)?$/.test(this.ruleForm.height)) {
            return this.$message.error("请按要求填写当前身高");
          }
        }
        if (this.ruleForm.weight) {
          if (!/^\d+(\.\d+)?$/.test(this.ruleForm.weight)) {
            return this.$message.error("请按要求填写当前体重");
          }
        }
        if (this.ruleForm.waistline) {
          if (!/^\d+(\.\d+)?$/.test(this.ruleForm.waistline)) {
            return this.$message.error("请按要求填写当前腰围");
          }
        }
        if (this.ruleForm.hipline) {
          if (!/^\d+(\.\d+)?$/.test(this.ruleForm.hipline)) {
            return this.$message.error("请按要求填写当前臀围");
          }
        }
        if (this.ruleForm.kcal) {
          if (!/^\d+(\.\d+)?$/.test(this.ruleForm.kcal)) {
            return this.$message.error("请按要求填写基础代谢");
          }
        }

        let height = Number(this.ruleForm.height);
        let weight = Number(this.ruleForm.weight);
        let waistline = Number(this.ruleForm.waistline);
        let hipline = Number(this.ruleForm.hipline);
        let kcal = Number(this.ruleForm.kcal);
        if (height > 9999.99) {
          return this.$message.error("请按要求填写当前身高");
        }
        if (String(height).split(".").length) {
          if (
            String(height).split(".").length == 2 &&
            String(height).split(".")[1].length > 2
          ) {
            return this.$message.error("请按要求填写当前身高");
          }
        }
        if (weight > 9999.99) {
          return this.$message.error("请按要求填写当前体重");
        }
        if (String(weight).split(".").length) {
          if (
            String(weight).split(".").length == 2 &&
            String(weight).split(".")[1].length > 2
          ) {
            return this.$message.error("请按要求填写当前体重");
          }
        }
        if (waistline > 9999.99) {
          return this.$message.error("请按要求填写当前腰围");
        }
        if (String(waistline).split(".").length) {
          if (
            String(waistline).split(".").length == 2 &&
            String(waistline).split(".")[1].length > 2
          ) {
            return this.$message.error("请按要求填写当前腰围");
          }
        }
        if (hipline > 9999.99) {
          return this.$message.error("请按要求填写当前臀围");
        }
        if (String(hipline).split(".").length) {
          if (
            String(hipline).split(".").length == 2 &&
            String(hipline).split(".")[1].length > 2
          ) {
            return this.$message.error("请按要求填写当前臀围");
          }
        }
        if (kcal > 999999.99) {
          return this.$message.error("请按要求填写基础代谢");
        }
        if (String(kcal).split(".").length) {
          if (
            String(kcal).split(".").length == 2 &&
            String(kcal).split(".")[1].length > 2
          ) {
            return this.$message.error("请按要求填写基础代谢");
          }
        }

        if (this.ruleForm.pregnancyStatus == 1) {
          if (!this.ruleForm.gestationalWeeks)
            return this.$message.error("请选择孕周");
          if (!this.ruleForm.pregnancyWeight)
            return this.$message.error("请输入孕前体重");
        }

        if (
          this.customForm.parentPhone &&
          !phoneReg.test(this.customForm.parentPhone)
        ) {
          this.$message.error("请输入正确格式的家长联系电话");
          return;
        }
        let data = {
          ...this.ruleForm
        };
        data.height = this.ruleForm.height ? Number(this.ruleForm.height) : "";
        data.weight = this.ruleForm.weight ? Number(this.ruleForm.weight) : "";
        data.waistline = Number(this.ruleForm.waistline);
        data.hipline = Number(this.ruleForm.hipline);
        data.kcal = Number(this.ruleForm.kcal);
        // 新增术语
        let jargonList = this.jargonList.map(item => {
          return {
            id: item.id,
            patientId: item.patientId,
            value: item.value
          };
        }); 
        let subParams = JSON.parse(JSON.stringify(this.ruleForm))
        if(!subParams.height){
          subParams.height = ''
        }
         if(!subParams.weight){
          subParams.weight = ''
        } 
        let customFormParam = DEEP_CLONE(this.customForm)
        customFormParam.retiredTime = customFormParam.retiredTime ? customFormParam.retiredTime : ''
        customFormParam.personalSituation = customFormParam.personalSituation.join(',')
        customFormParam.physicalExercise = this.otherExercise ?  customFormParam.physicalExercise.join(',') + `,${this.otherExercise}` : customFormParam.physicalExercise.join(',')
        customFormParam.treatment = customFormParam.treatment.join(',')
        Promise.all([
          UpdatepatientArchiesLeft(subParams),
          terminologyMultipleInsert(jargonList),
          updateCustome({...subParams,...customFormParam})
        ])
          .then(result => {
            this.$message.success("修改成功");
            this.isEdit = false; 
            this.$emit("userEdit", 1); 
          })
          .catch(error => {
            this.loading = false;
          });
      }
    },
    regionAll() {
      regionAll().then(res => {
        if (res.code == 0) {
          this.options = res.data;
        }
      });
    },
    addressChange(e) { 
      this.customForm.province = e[0];
      this.customForm.city = e[1];
      this.customForm.county = e[2];
      console.log(this.customForm.cityList, "customForm.cityList");
    },
    cancerNameTextChange(e) {
      this.$set(this.customForm, "cancerNameText", e);
      if (e != "其他") {
        this.$set(this.customForm, "cancerName", e);
      } else {
        this.$set(this.customForm, "cancerName", "");
      }
      console.log(this.customForm.cancerNameText, "sss");
      this.$forceUpdate();
    }
  },

  filters: {
    gestationalWeeksFilts(value) {
      if (value <= 12) {
        return ` ${value} ` + "[孕早期]";
      } else if (value <= 25) {
        return ` ${value} ` + "[孕中期]";
      } else {
        return ` ${value} ` + "[孕晚期]";
      }
    },
    bloodTypeFilt(value) {
      switch (value * 1) {
        case 1:
          return "A型";
        case 2:
          return "B型";
        case 3:
          return "AB型";
        case 4:
          return "O型";
        case 5:
          return "不清楚";
        default:
          return "";
      }
    },
    labourFilte(value) {
      switch (value * 1) {
        case 1:
          return "轻体力劳动";
        case 2:
          return "中等体力劳动";
        case 3:
          return "重体力劳动";
        case 4:
          return "极重体力劳动";
        default:
          return "";
      }
    },
    embryoNumberFilte(value) {
      switch (value * 1) {
        case 1:
          return "单胎";
        case 2:
          return "双胎";
        case 3:
          return "多胎";
        default:
          return "";
      }
    }
  }
};
</script>
<style>
  .info .link-box{
    width: 420px;
  }
  .case-name .add-time-dialog{
    left: -30px;
  } 
</style>
<style scoped lang="less">
@import "./index.less"; 
.kins-folk-info {
  position: absolute;
  top: -100px;
  right: -345px;
  z-index: 2;
  /deep/.el-form-item {
    margin-bottom: 22px;
  }
}
.case-name .kins-folk-info{
  top:28px;
  left: -160px; 
}
.form-class{
  padding-top: 20px;
  .el-input,.el-select{
    width: 220px;
  }
}
.tooltip-form{
  .el-input{
     width: 220px;
  }
}
.fill-card-title {
  font-size: 12px;
  color: #666666;
  line-height: 10px;
  margin-bottom: 20px;
}
.open-tag{
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  .tag-title{ 
    font-size: 14px; 
    font-weight: bold;
    color: rgba(0,0,0,0.85); 
    display: flex;
    align-items: center; 
  }
  .open-status{
    color: #333; 
    cursor: pointer;
    i{
      margin-left:6px;
    }
  }
  span{
    display: inline-block;
    width: 4px;
    height: 15px;
    background: #1A7BFC;
    margin-right: 10px;
  }
}
</style>

<style lang="less">
.basic-drawer {
  height: calc(100% - 72px);
  padding: 0 24px 10px;
  background: #fff;
}
</style>